module.exports = __webpack_public_path__ + "static/media/logogastro.769e95b1.png";